module.exports = __webpack_public_path__ + "img/shtastliveca.99194ae4.jpg";